export const formatColor = (color?: string) => {
  if (!color) return ''
  if (color.startsWith('#') && color.length === 9) {
    // 提取透明度 AA
    const alpha = color.slice(1, 3)
    // 提取颜色 RRGGBB
    const rgb = color.slice(3)
    // 重新拼装为 #RRGGBBAA
    return '#' + rgb + alpha
  }
  return color
}
